export type EffectivePaymentStatus =
  | 'pending'
  | 'overdue'
  | 'paid'
  | 'cancelled'
  | 'partially_paid';

function localTodayIso(): string {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function getEffectivePaymentStatus(params: {
  status?: string | null;
  dueDate?: string | null;
  amount?: number | null;
  paidAmount?: number | null;
  balance?: number | null;
}): EffectivePaymentStatus {
  const status = String(params.status || '').toLowerCase().trim();
  const dueDate = params.dueDate ? String(params.dueDate).slice(0, 10) : null;
  const amount = Number(params.amount || 0);
  const paidAmount = Number(params.paidAmount || 0);
  const derivedBalance =
    Number.isFinite(Number(params.balance))
      ? Number(params.balance)
      : Math.max(amount - paidAmount, 0);

  if (status === 'paid' || (amount > 0 && paidAmount >= amount) || derivedBalance <= 0) return 'paid';
  if (status === 'cancelled') return 'cancelled';
  if (status === 'partially_paid') return 'partially_paid';

  if (!dueDate) return 'pending';
  return dueDate < localTodayIso() ? 'overdue' : 'pending';
}

